import { useLazyQuery, gql } from "@apollo/client";
import React from "react";
import { Icon, Loader } from "semantic-ui-react";
import { generateRoutePath } from "/imports/client/router/routes-helpers";

import Debug from "debug";
const debug = Debug("invoiceTag");

export interface IInvoiceTagProps {
  invoiceId: string;
  number?: string;
  showLink?: boolean;
  linkParams?: object;
}

export const GET_INVOICE_HEADER = gql`
  query getInvoiceForTag($invoiceId: String!) {
    invoice: getInvoice(invoiceId: $invoiceId) {
      id
      number
    }
  }
`;

const InvoiceTag = ({ number, invoiceId, showLink, linkParams }: IInvoiceTagProps) => {
  let path = generateRoutePath("invoice", { _id: invoiceId, section: "data" });
  if (linkParams){
    path += `?${new URLSearchParams({...linkParams}).toString()}`
  }
  return (
    <>
      {number || "Invoice"}
      {showLink && (
        <a
          href={path}
        >
          <Icon name="share square" color="grey" />
        </a>
      )}
    </>
  )
};

const InvoiceTagLoader = ({
  invoiceId,
  number,
  showLink,
  linkParams
}: IInvoiceTagProps) => {
  const [
    getInvoice,
    { data = {}, loading, error, called }
  ] = useLazyQuery(GET_INVOICE_HEADER, { variables: { invoiceId } });

  if (error) debug("error in data fetch %o", error);

  if (!number && !invoiceId) return <> - </>;
  if (!number && invoiceId && !called) getInvoice();
  const invoiceNumber = number || data.invoice?.number;

  return loading ? (
    <Loader active inline />
  ) : (
    <InvoiceTag
      number={invoiceNumber}
      invoiceId={invoiceId}
      showLink={showLink}
      linkParams={linkParams}
    />
  );
};

export default InvoiceTagLoader;
